import { render, staticRenderFns } from "./jyf-parser.vue?vue&type=template&id=6a07ba30&scoped=true"
import script from "./jyf-parser.vue?vue&type=script&lang=js"
export * from "./jyf-parser.vue?vue&type=script&lang=js"
import style0 from "./jyf-parser.vue?vue&type=style&index=0&id=6a07ba30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a07ba30",
  null
  
)

export default component.exports